import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClientThemingService {
  private themeLink?: HTMLLinkElement;

  /**
   * Attempts to load an organization's custom theming classes
   * @param organizationId
   */
  public loadOrganizationCss(organizationId: string): void {
    // Remove previous theme if it is present
    if (this.themeLink) {
      this.themeLink.remove();
    }

    this.themeLink = document.createElement('link');
    this.themeLink.rel = 'stylesheet';
    this.themeLink.href = `assets/styles/custom/${organizationId}/customStyle.css`;

    document.head.appendChild(this.themeLink);
  }
}
